{
	"elementNofound": "Element for render no found",
	"byDay": "por día",
	"CalendarDay": "Por días",
	"coverages": "Coberturas",
	"transmission": "Transmisión",
	"BasicPlus": "Total",
	"Only": "Sólo carro",
	"onlyCar": "Sólo carro",
	"Basic": "Básica",
	"Full": "Total + combustible",
	"thisCoverageIncludes": "Esta cobertura incluye",
	"automatic": "Automático",
	"manual": "Manual",
	"amountPassengers": "Cantidad pasajeros",
	"amountDoors": "Cantidad puertas",
	"airConditioning": "Aire acondicionado",
	"amountBaggage": "Cantidad maletas",
	"theftProtectionPartial": "TP-Seguro robo( Parcial )",
	"collisionDamageWaiver": "Seguro de Colisión Choque y Robo (CDW – TP)",
	"superCollisionDamageWaiver": "SCDW-Super Cover.",
	"personalAccidentInsurances": "PAI-Seguro personal contra accidentes.",
	"theftProtection": "TP-Seguro contra robo.",
	"taxes": "TAX-Impuestos",
	"insurances": "Seguros",
	"lowDamageWaiver": "LDW-Seguro colisión y robo",
	"liabilitySupplementalInsurance": "LIS-Daños a terceros",
	"secondDriver": "ADDDRV-2° conductor",
	"fullGas": "GAS-Un tanque de gasolina",
	"book": "Reservar",
	"dailyRateText": "Día",
	"yes": "Si",
	"couldNotGetAgency": "Lo sentimos, no se pudo obtener la agencia",
	"noResultsForSelectedDates": "El servicio de renta de auto no está disponible en este destino.",
	"collisionDamageWaiverPartial": "CDW-Seguro colisión ( Parcial ).",
	"selectYourDestination": "Selecciona tu destino",
	"dropOffLocation": "Lugar de entrega",
	"addYourDestination": "Agrega tu destino",
	"selectYourDates": "Selecciona tus fechas",
	"labelDates": "Fechas",
	"addYourDates": "Agrega tus fechas",
	"selectYourDiscount": "Selecciona tu descuento",
	"withoutDiscount": "Sin descuento",
	"payOnLine": "Pago en línea",
	"discounts": "Descuentos",
	"discount": "Descuento",
	"selectADiscount": "Selecciona un descuento",
	"haveMyOwnDiscount": "Tengo mi propio descuento",
	"promotionalCode": "Código promocional",
	"selectApromotionalCode": "Selecciona un código promocional",
	"haveMyOwnPromotionalCode": "Tengo mi propio código promocional",
	"hertzGold": "Hertz Gold ",
	"enterTheCodeHertzGold": "Ingresa tu código Hertz",
	"enterYourHertzGoldCodeHere": "Ingresa aqui tu código hertz gold",
	"add": "Agregar",
	"youSaveUpToDescription": "Ahorras hasta un 30% seleccionando ésta opción.",
	"paymentOnArrival": "Pago en destino",
	"startYourSearch": "Empieza tu busqueda",
	"returnTheCarInTheSamePlace": "Devolver el auto en el mismo lugar",
	"searchByLocations": "Busca por localidades",
	"selectHours": "Seleccionar horas",
	"pickup": "Recogida",
	"return": "Devolución",
	"delivery": "Entrega",
	"ready": "Listo",
	"enterADiscount": "Ingrese un descuento",
	"enterAPromoCode": "Ingrese un código promocional",
	"enterAPromocode": "Ingresa tu código promocional",
	"enterValidPromoCode": "Ingresa un código válido",
	"saveUpByAddingYourGoldHertzCode": "Ahorra hasta un 30% agregando tu código Gold Hertz",
	"next": "Siguiente",
	"back": "Atrás",
	"finalize": "Finalizar",
	"getBack": "Regresar",
	"viewDeal": "Ver oferta",
	"airportList": "Lista de Aeropuertos",
	"cityList": "Lista de ciudades",
	"selectYourDelivery": "Selecciona tu entrega",
	"selectYourHertzGold": "Selecciona tu Hertz Gold",
	"withoutHertzGold": "Sin Hertz Gold",
	"noHertzGold": "¿No tienes Hertz Gold?",
	"addItHere": "Agrégalo aquí",
	"select": "Seleccionar",
	"selectGuests": "Seleccionar huéspedes",
	"localities": "Localidades",
	"localittiesNoFound": "Lo sentimos, no hemos encontrado ningún resultado. Te recomendamos a buscar de nuevo con otra ciudad.",
	"results": "Resultados",
	"selectYourDiscounts": "Selecciona tus descuentos",
	"weSorry": "Lo sentimos",
	"search": "Buscar",
	"returnTheCarInOtherPlace": "Devolver el auto en otro lugar",
	"first": "Primera",
	"economic": "Económica",
	"business": "Negocio",
	"economy": "Turista",
	"premiumEconomy": "Económica Premium",
	"premiumFirst": "Primera Premium",
	"premiumBusiness": "Ejecutiva Premium",
	"allClassesLabel": "Todas las clases",
	"origin": "Origen",
	"destination": "Destino",
	"passengersAndClass": "Pasajeros & Clase",
	"selectTheClass": "Elige la clase",
	"adult": "Adulto",
	"adults": "Adultos",
	"adultsDescription": "Mayores de 12 años",
	"child": "Niño",
	"children": "Niños",
	"childrenDescription": "De 2 a 11 años",
	"infant": "Infante",
	"infants": "Infantes",
	"infantsDescription": "Menores de 2 años",
	"all": "Todas",
	"comeBack": "Volver",
	"roundTrip": "Ida y vuelta",
	"onewayTrip": "Solo ida",
	"multiTrip": "Multidestino",
	"airline": "Aerolínea",
	"searchTheAirline": "Busca la aerolínea",
	"onlyDirectFlights": "Solo vuelos directos",
	"addFlight": "Agregar trayecto",
	"removeFlight": "Quitar trayecto",
	"startYourFlightsSearch": "Empieza tu busqueda",
	"ageOfChild": "Edad del Menor",
	"adultsAndChildren": "Adultos y Menores",
	"room": "Habitación",
	"removeRoom": "Eliminar Habitación",
	"addRoom": "Agregar Habitación",
	"destinationsList": "Lista de destinos",
	"selectYourDate": "Selecciona tu fecha",
	"passengers": "Pasajeros",
	"passenger": "Pasajero",
	"ageOfPassenger": "Edad del pasajero",
	"startYourHotelsSearch": "Empieza tu busqueda",
	"startYourActivitiesSearch": "Empieza tu busqueda",
	"howManyDays": "¿Cuántos días en los parques?",
	"withPromoCode": "Tengo un código promocional",
	"promoCode": "Código promocional",
	"errorDateMinFlightMulti": "La fecha debe ser mayor a la anterior",
	"freeEntranceMessage": "Entrada gratuita para menores de 3 años (al momento de entrar al parque).",
	"adultsDisneyDescription": "Mayores de 10 años",
	"childrenDisneyDescription": "Entre 3 y 9 años",
	"childrenThreeToNineYears": "De 3 a 9 años",
	"threeToNineYears": "3 a 9 años",
	"infantDisneyDescription": "Niños menores de 3 años ingresan gratis al parque",
	"Mundial": "Mundial",
	"Domestic": "Nacional",
	"LATAM": "América latina",
	"USA": "Estados unidos",
	"EU": "Europa",
	"childOrAdult": "Joven o adulto",
	"childrenOrAdults": "Jovenes o adultos",
	"childrenAndAdults": "Jovenes y adultos",
	"olderAdult": "Adulto mayor",
	"olderAdults": "Adultos mayores",
	"olderAdultsDescription": "Entre 75 y 85 años",
	"childrenAndAdultsDescription": "Entre 0 y 74 años",
	"annualCoverage": "Cobertura anual",
	"CalendarAnnual": "Anual",
	"datesMessage": "Selecciona una estadía de máximo 28 días.",
	"parks": "Parque",
	"allParks": "Todos los Parques (Orlando)",
	"checkIn": "Fecha de ingreso",
	"checkOut": "Fecha de retiro",
	"checkInLabel": "Ingreso",
	"checkOutLabel": "Salida",
	"one": "1",
	"two": "2",
	"addYourTicketsToPackages": "Agrega tus entrada a parques",
	"selectDate": "Selecciona la fecha de tu entrada para conocer el precio total.",
	"days": "Dias",
	"improveTicket": "Mejora tu tipo de entrada",
	"VisitMultipleParks": "Visita un parque o varios parques por día, ¡varios parques con más diversión adicional!",
	"entrance": "Entrada",
	"price": "Precio",
	"nights": "Noches",
	"plusSign": "+",
	"packages": "paquetes",
	"of": "de",
	"taxesFees": "Impuestos y cargos: Incluidos",
	"disney": "disney",
	"reservationDetails": "Detalles de reserva",
	"reserve": "Reservar",
	"addonsAlert": "Lo sentimos, actualmente no tenemos parques disponibles para tu selección; por favor intenta otro día de ingreso a parque",
	"selectYourNationality": "Selecciona tu nacionalidad",
	"country": "País",
	"searchYourCountry": "Busca tu país",
	"startDisneyExperience": "Comienza tu Experiencia Disney",
	"buyYourStandardTickets": "Compra tus entradas estándar o escoge",
	"moreOptionsToEnjoy": "más opciones para disfrutar de tu estadía",
	"theMoreDaysYouChoose": "Entre más días escojas, menos pagarás por día.",
	"rememberCheckAvailabilityParks": "Recuerda verificar la disponibilidad de los parques antes de comprar",
	"seeCalendar": "Ver calendario",
	"class": "Clase",
	"passengersAndAirlines": "Pasajeros & aerolíneas",
	"optionalLabel": "Opcional",
	"requiredField": "Completa este campo",
	"requiredFieldOrigin": "El campo origen es obligatorio",
	"requiredFieldDestination": "El campo destino es obligatorio",
	"requiredFieldDates": "El campo fechas es obligatorio",
	"requiredFieldPickup": "El campo recogida es obligatorio",
	"requiredFieldReturn": "El campo devolución es obligatorio",
	"invalidStayLength": "Selecciona al menos una noche",
	"completeField": "Completa el campo",
	"cancel": "Cancelar",
	"apply": "Aplicar",
	"selectAnOrigin": "Selecciona un origen",
	"selectOrigin": "Seleccionar origen",
	"selectADestination": "Selecciona un destino",
	"selectDestination": "Seleccionar destino",
	"selectAnOption": "Selecciona una opción",
	"maximumAgeRestrictionMessageForChildren": "El valor debe ser igual/menor a 17",
	"messageMinimumAgeRestrictionForChildren": "El valor debe ser igual/mayor a 1",
	"points": "Puntos",
	"consultMyPoints": "Consultar mis puntos",
	"inputYourData": "Ingrese los datos de su",
	"bacCreditCard": "Tarjeta de crédito BAC",
	"forConsultingPoints": "para consultar cuántos puntos o millas tiene acumulados.",
	"cardHolderName": "Nombre del titular",
	"cardNumber": "Número de tarjeta",
	"expirationDate": "Fecha de expiración",
	"cvc": "CVV",
	"consulting": "Consultando...",
	"consult": "Consultar",
	"availableKey": "disponibles",
	"toConsultPoints": "Para consultar sus puntos o millas,",
	"mustEnterData": "debe ingresar una tarjeta de crédito de BAC.",
	"consultedCreditCard": "Tarjeta de crédito consultada",
	"close": "Cerrar",
	"consultAnotherCard": "Consultar otra tarjeta",
	"clearConsult": "Limpiar consulta",
	"clearConsultTitle": "¿Limpiar toda la consulta?",
	"clearConsultMessage": "Se eliminarán las tarjetas consultadas del navegador.",
	"confirmClear": "Sí, limpiar",
	"allDone": "Todo listo",
	"clearDoneMessage": "Borramos los datos de tu consulta. Podés seguir explorando opciones para tu viaje.",
	"continueBrowsing": "Continuar navegando",
	"carsDisclaimer": "Por el momento este servicio no está disponible para destinos nacionales",
	"ticketsForSpecialEvents": "Tickets para Eventos Especiales",
	"buyNow": "Comprar ahora",
	"selectYourPassengers": "Selecciona pasajeros",
	"betweenOneAndSeventeenYears": "Entre 1 y 17 años",
	"overEighteenYears": "Mayor de 18 años",
	"flight": "Vuelo",
	"addAnotherFlight": "Agregar otro vuelo",
	"searchFlights": "Buscar vuelos",
	"remove": "Eliminar",
	"whereTravel": "¿A dónde viaja?",
	"whenTravel": "¿Cuándo viaja?",
	"travelFrom": "Viajo desde",
	"travelTo": "Viajo hacia",
	"departureDate": "Fecha de salida",
	"startDateLabel": "Inicio",
	"departingDate": "Fecha de ida",
	"returnDate": "Fecha de regreso",
	"endDateLabel": "Fin",
	"three": "3",
	"selected": "Seleccionado",
	"addMealPlan": "Agrega tu plan de comida",
	"mealPlan": "Plan de comida",
	"ticket": "Ticket",
	"mealPlanHighlights": "Aspectos destacados del plan de comidas",
	"roomOnly": "Solo habitación",
	"planIncluded": "Plan incluido",
	"verifyInformation": "Para continuar, verifique la siguiente información:",
	"verifyStatusCard": "• Valide el estatus de su tarjeta.",
	"validateCardAffiliated": "• Valide que su tarjeta está afiliado a un plan de lealtad de puntos o millas.",
	"checkCardAgain": "Consulte de nuevo su tarjeta ",
	"contactCustomer": "o contacte a servicio al cliente de BAC para más información.",
	"unableVerifyCard": "No pudimos consultar la tarjeta ingresada",
	"guests": "Huéspedes",
	"hour": "Hora",
	"deliveryDate": "Fecha de entrega",
	"pickupDate": "Fecha de recogida",
	"cities": "Ciudades",
	"airports": "Aeropuertos",
	"seeAllLocations": "Ver todas las localidades",
	"selectPickup": "Seleccionar recogida",
	"selectReturn": "Seleccionar devolución",
	"selectPluralDates": "Seleccionar fechas",
	"selectSingularDate": "Seleccionar fecha",
	"visitors": "Visitantes",
	"selectPassengers": "Seleccionar pasajeros",
	"age": "Edad",
	"childrenLessOneYearMsg": "Los bebés menores de un año no es necesario registrarlos.",
	"adultsDescriptionHotels": "Igual o mayores de 18 años",
	"childrenDescriptionHotles": "de 1 a 17 años",
	"pluralOverEighteenYears": "Mayores de 18 años",
	"pluralBaby": "Bebés",
	"singularBaby": "Bebé",
	"sinceTwelveYears": "Desde 12 años",
	"rooms": "Habitaciones",
	"followUs": "Síguenos en",
	"loginNow": "Ingresa ahora",
	"frequentQuestions": "Preguntas frecuentes",
	"chatWithUs": "Chatea con nosotros",
	"yourMiles": "Tienes",
	"myProfile": "Mi perfil",
	"myMiles": "Mis millas",
	"myExchanges": "Mis canjes",
	"logOutCME": "Cerrar sesión",
	"loginCME": "Iniciar sesión",
	"availabilitySearchesUpcomingMonths": "Las búsquedas están disponibles solo dentro de los próximos 12 meses.",
	"searchNotAllowed": "Lo sentimos, búsqueda no permitida",
	"youAreSearchingForADisallowedSeason": "Estás realizando una búsqueda para una temporada no permitida",
	"ok": "OK",
	"bookingConditionsNotCompliant": "Las condiciones de reservación no cumplen con las políticas del programa",
	"learnMoreAt": "Conoce más en los",
	"termsAndConditions": "Términos y condiciones",
	"recentSearches": "Búsquedas recientes",
	"removeAll": "Borrar todo",
	"assistants": "Asistentes",
	"assistances": "Asistencias",
	"freeEntranceDescription": "Entrada gratis para menores de 3 años. No se te cobrará por el menor al momento de ingresar al parque.",
	"minTotalPassengersNotCompliant": "Debes seleccionar al menos {{min}} pasajeros",
	"yourCertificateIsNotValidForTheSelectedDates": "Las condiciones de reservación no cumplen con las políticas del programa",
	"ageOfAssistant": "Edad del asistente",
	"loginPromerica": "Iniciar sesión",
	"selectCountry": "Selecciona tu país",
	"titleFooterSectionPromericaMobile": "Descarga la app",
	"descriptionSectionMobilePromericaFooter": "Personaliza tu experiencia con nuestra App Club Promerica.",
	"descriptionPromericaFooter": "Impulsamos una banca que desarrolle relaciones con nuestras comunidades para ayudarles a superar sus límites.",
	"accept": "Aceptar",
	"minutes": "Minutos",
	"hours": "Horas",
	"searchPromerica": "Búsqueda",
	"selectTheAge": "Selecciona la edad",
	"twelveYearsAndUp": "12 años en adelante",
	"tenYearsAndUp": "10 años en adelante",
	"journey": "Trayecto",
	"flights": "Vuelos",
	"chooseRoute": "Elige tu ruta",
	"chooseOrigin": "Elige el lugar de origen",
	"chooseDestination": "Elige el lugar de destino",
	"choosePassengers": "Selecciona los pasajeros",
	"whereDoYouWantToGo": "¿A dónde te quieres ir?",
	"whereDoYouWantToTravel": "¿A dónde quieres viajar?",
	"startSearch": "Comienza tu búsqueda",
	"childrenDescriptionInfo": "Los vuelos con menores tienen condiciones especiales. Los niños deben viajar en compañía de un adulto.",
	"infantsDescriptionInfo": "El bebé solo puede viajar en brazos del adulto. Si quieres asignarle un asiento, debes agregarlo como niño.",
	"childrenDescriptionsHotels": "Los menores de edad deben hospedarse en compañía de un adulto.",
	"sinceEighteenYears": "Desde 18 años",
	"sinceEighteenYearsModern": "18 años en adelante",
	"upToSeventeenYears": "De 0 a 17 años",
	"night": "Noche",
	"hotels": "Hoteles",
	"chooseGuests": "Selecciona los huéspedes",
	"whereDoYouWantToStay": "¿En dónde te quieres hospedar?",
	"hotelList": "Lista de hoteles",
	"deliveryDateTime": "Fecha y hora de entrega",
	"nationality": "Nacionalidad",
	"whereDoYouWantToDrive": "¿En dónde quieres conducir?",
	"cars": "Autos",
	"datesMessageProductCars": "Selecciona una renta de máximo 62 días",
	"deliverCarInOtherPlace": "Entregar el auto en otro lugar",
	"pickupLocation": "Lugar de recogida",
	"dropOffLocationModern": "Lugar de entrega",
	"dropOffLocationShort": "entrega",
	"pickupAndDropOffLocation": "Lugar de recogida y entrega",
	"hertzGoldCodeModern": "Código Hertz Gold",
	"hertzGoldPlaceholderModern": "Ingresa código Hertz Gold",
	"hertzGoldSecondPlaceholderModern": "Ingresa código Hertz Gold",
	"discountCodeModern": "Código de descuento",
	"discountPlaceholderModern": "Selecciona tu código de descuento",
	"ageOfBoy": "Edad del niño",
	"whatExperienceDoYouWantToLive": "¿Qué experiencia quieres vivir?",
	"fromOneToSeventeenYearsOld": "1 a 17 años",
	"TitleActivitiesInMobile": "Actividades",
	"selectYourDatesInMobile": "Selecciona tus fechas",
	"labelDatepicker": "Fechas",
	"selectYourAssistantsInMobile": "Selecciona los asistentes",
	"disneyMobileSearchTitle": "¿Cómo quieres disfrutar?",
	"disneyLabelMobile": "Disney",
	"disneySearchDisclaimer": "Tu búsqueda se realizará en todos los Hoteles de Disney disponibles en Orlando",
	"freeEntranceTitle": "Entrada gratis para menores de 3 años",
	"freeEntranceSubtitle": "Al momento de ingresar al parque.",
	"enterDestination": "Ingresa el destino",
	"popularDestinations": "Destinos Populares",
	"selectAgeForEachChild": "Selecciona la edad de cada niño",
	"labelCityOrHotelName":"Ciudad o nombre del hotel",
	"labelSelectYourDateAndTime":"Selecciona tu fecha y hora",
	"minute": "Minuto",
	"directFlights": "Vuelos directos",
	"hertzCode": "Código Hertz",
	"enterYourCodeHere": "Ingresa aqui tu código",
	"year": "año",
	"years": "años",
	"visitor": "Visitante"
}
